<template>
  <div class="box">
    <van-nav-bar :title="title" />
    <van-notice-bar
        left-icon="volume-o"
        mode="closeable"
        text="本消息为留言消息，工作人员将会在1-3个工作日内回复。请耐心等待！"
        />
    <div class="body-box" id="body-box" ref="scrollDiv">
<!--  -->
<div v-for="(item,i) in listData" :key="i">
    <!-- 学生  -->
    <div class="messageLi" v-if="+item.level==0">
        <div style="font-size:12px;color:#818080;">{{item.createTime}}</div>
        <div><span  style="color:#818080;">{{userInfo.studentName}} : </span>{{item.note}} </div>
    </div>
    <!-- 教师回复 -->
    <div class="messageLiV2" v-if="+item.level==1">
        <div  style="font-size:12px;color:#818080;">{{item.createTime}}</div>
        <div><span   style="color:#818080;">教师回复 : </span>{{item.note}} </div>
    </div>
</div>
    </div>
    <div class="bottom-box">
  <van-field
  class="bottom-input"
  v-model="message"
  rows="1"
  autosize
  border
  type="textarea"
  placeholder="请输入留言"
>
  <template #button>
    <van-button size="normal" type="primary" @click="onSend">发送</van-button>
  </template>
</van-field>
    </div>

  </div>
</template>

<script>
// import {  getFitnessStudentChatPageList,saveStudentChat,clickNewChat } from '../../api/messageBoardMgt'

export default {
    data () {
        return {
            listData:[],
            userInfo:{},
            message:'',
            title:'留言板'
        }
    },
     watch: {
    // 监听当前消息列表，更新时，保持滚动条位于底部
    listData: function scrollToBottom () {
      this.$nextTick(() => {
        var message = document.getElementById('body-box')
        // 滚动滑钮到滚动条顶部的距离=滚动条的高度
        message.scrollTop = message.scrollHeight
      })
    }
  },
    mounted () {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    if (this.userInfo&&this.userInfo.snCode) {
    this.init()
    }
    },
    methods:{
        scrollToBottom (){
                // this.$nextTick(() => {
                //     let scrollElem = this.$refs.scrollDiv;
                //     scrollElem.scrollTo({ top: scrollElem .scrollHeight, behavior: 'smooth' });
                // });
                var container = document.getElementById('body-box')
                container.scrollTop=container.scrollHeight
                debugger
        },
init(){
    getFitnessStudentChatPageList({snCode:this.userInfo.snCode,current:'1',pageSize:'999999999'}).then(res=>{
        console.log(res);
        this.listData = res.body.body.list
    })
    clickNewChat({snCode:this.userInfo.snCode,}).then(()=>{

    })
},
onSend(){
    if (this.message=='') {
        return
    }
    saveStudentChat({
        snCode:this.userInfo.snCode,
        note:this.message
    }).then(res=>{
        this.message=''
        this.init()
    })
}
    }

}
</script>

<style lang="less" scoped>
.box{
    position: relative;
    // background-color: #fff;
    height: 100vh;
    .body-box{
        height: calc(100vh - 118px);
        padding: 8px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .messageLi{
        background-color: #fff;
        border-radius: 5px;
        font-size: 13px;
        line-height: 20px;
        padding: 5px;
        margin: 5px;
        
    }
    .messageLiV2{
        background-color: #b8e281;
        border-radius: 5px;
        font-size: 13px;
        line-height: 20px;
        padding: 5px;
        margin: 5px;
    }
    .bottom-box{
        position: absolute;
        bottom: 0;
        .bottom-input{
            width: 100vw;
        }
        .bottom-button{
            width: 100px;
            height: 50px;
        }
    }
}
</style>